import { actions } from '../constants/free_mobile_fitting_light_box/actions';
import Dispatcher from '../dispatcher';

export const show = () =>
    Dispatcher.handleFreeMobilFittingLightBoxAction({ type: actions.SHOW });

export const hide = () =>
    Dispatcher.handleFreeMobilFittingLightBoxAction({ type: actions.HIDE });
